import { PHONE, locationSchema } from "../structured-data-core";

export function getOklahomaCityStructuredData() {
  const url = "https://restorehair.com/locations/oklahoma/oklahoma-city/";
  const description =
    "Find out about your hair transplant options in Oklahoma City with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Oklahoma City", "101 Park Ave, Suite 1300", "Oklahoma City", "OK", PHONE, url, description),
  ];
}
